import { Row, Table } from 'antd';
import { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import Detail from '../Detail';

import './style.scss';

import TableAdmin from '@/components/TableAdmin';
import { JPY } from '@/constants/character';
import revenueService from '@/services/revenue.service';
import { handleMessageError } from '@/util/handleMessageError';
import { numberFormatWithComma } from '@/util/numberFormatWithComma';
interface IProps {
    data: any[];
    total: any;
    isLoading: boolean;
}
const Content: React.FC<IProps> = ({ data = [], total, isLoading }) => {
    const { t } = useTranslation(['common', 'revenue']);

    const columns = [
        {
            title: t('SLIP_NO'),
            dataIndex: 'salesNo',
            align: 'center',
        },
        {
            title: t('ACCOUNTING_TIME'),
            align: 'center',
            dataIndex: 'salesTime',
            render: (value: string) => {
                return <>{value}</>;
            },
        },

        {
            title: t('ACCOUNTING_CLASSIFICATION'),
            align: 'center',
            dataIndex: 'salesDiv',
            render: (value: string) => {
                return <>{+value === 2 ? t('revenue:AKENDA') : t('revenue:T_REGULAR')}</>;
            },
        },

        {
            title: t('DETAILED_ACCOUNGTING'),
            align: 'right',
            dataIndex: 'detailTotal',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },
        {
            title: t('DETAIL_DISCOUNT'),
            align: 'right',
            dataIndex: 'discountDetailTotal',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        {
            title: t('SUB_TOTAL'),
            align: 'right',
            dataIndex: 'subTotal',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        {
            title: t('VOUCHER_DISCOUNT'),
            align: 'right',
            dataIndex: 'discountPrice',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },
        {
            title: t('PAIR_DISCOUNT'),
            align: 'right',
            dataIndex: 'discountCouplePrice',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },
        {
            title: t('APP_DISCOUNT'),
            align: 'right',
            dataIndex: 'discountMobileAppPrice',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        {
            title: t('SHORTFALL'),
            align: 'right',
            dataIndex: 'feeDifferent',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        {
            title: t('TOTAL_REVENUE'),
            align: 'right',
            dataIndex: 'total',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        {
            title: t('TAX'),
            align: 'right',
            dataIndex: 'tax',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        {
            title: t('CASH'),
            align: 'right',
            dataIndex: 'cash',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },

        // {
        //     title: t('GOLD_TICKET'),
        //     align: 'right',
        //     dataIndex: 'goldTicket',
        // },

        {
            title: t('CREDIT'),
            align: 'right',
            dataIndex: 'credit',
            render: (value: number) => numberFormatWithComma(value, JPY),
        },
        // {
        //     title: t('ACCOUNTS_RECEIVABLE'),
        //     dataIndex: 'receivable',
        //     align: 'right',
        //     render: (value: number) => numberFormatWithComma(value, JPY),
        // },
        {
            title: t('MANAGER'),
            dataIndex: 'editStaffName',
        },
    ];

    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [saleId, setSaleId] = useState<number>();

    const onRowHandle = useCallback((data: any) => {
        setIsVisible(true);
        setSaleId(data?.id);
    }, []);

    const {
        isLoading: isLoadingDetail,
        data: revenueDetail,
        refetch,
    } = useQuery(['revenue', saleId], () => revenueService.getRevenueDetail(saleId), {
        enabled: !!saleId,
        onError: (error: any) => {
            handleMessageError(error, t);
        },
    });

    useEffect(() => {
        if (saleId) {
            refetch();
        }
    }, [saleId, refetch]);

    return (
        <div className="p-revenue-content">
            {total && (
                <div className="content-info">
                    <span>
                        {`${t('revenue:T_NUMBER_SALE')}`}
                        {total?.numberOfSales | 0}
                    </span>
                    <span>
                        {`${t('revenue:T_AKADEN_NUMBER')}`}
                        {total?.numberOfRedSlips | 0}
                    </span>
                </div>
            )}
            <TableAdmin
                loading={isLoading || isLoadingDetail}
                pointer={true}
                onRow={onRowHandle}
                columns={columns}
                data={data}
                scroll={{ x: 2000 }}
                rowKey="id"
                summary={() => {
                    return (
                        <>
                            {data.length > 0 ? (
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} colSpan={3}>
                                        <Row justify="center">
                                            <strong>{t('GOKEI')}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    {/* <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{total?.numberOfRedSlips}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{total?.numberOfSales}</strong>
                                        </Row>
                                    </Table.Summary.Cell> */}
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_detailTotal, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>
                                                {numberFormatWithComma(total?.sum_discountDetailTotal, JPY)}
                                            </strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_subTotal, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_discountPrice, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            {numberFormatWithComma(total?.sum_discountCouplePrice, JPY)}
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>
                                                {numberFormatWithComma(total?.sum_discountMobileAppPrice, JPY)}
                                            </strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>
                                                {numberFormatWithComma(total?.sum_feeDifferent, JPY)}
                                            </strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_total, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_tax, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_cash, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_credit, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell>
                                    {/* <Table.Summary.Cell index={1}>
                                        <Row justify="end">
                                            <strong>{numberFormatWithComma(total?.sum_receivable, JPY)}</strong>
                                        </Row>
                                    </Table.Summary.Cell> */}
                                </Table.Summary.Row>
                            ) : (
                                ''
                            )}
                        </>
                    );
                }}
            />
            <Detail onCancel={(data: boolean) => setIsVisible(data)} isVisible={isVisible} data={revenueDetail} />
        </div>
    );
};

export default memo(Content);
